import { MapPin } from "@phosphor-icons/react";
import { getIndochinaTime, timeDifference } from "../Home";

const CardHistory = ({ cb }) => {
  const thoseDay = new Date(cb.check_in);
  const dayToday = thoseDay.toLocaleDateString("en-GB", { day: "numeric" });
  const dayDay = thoseDay.toLocaleDateString("en-GB", { weekday: "short" });

  return (
    <div className="p-2 rounded-lg shadow flex flex-col gap-2 bg-slate-50">
      {cb.name && (
        <div className="flex border-b border-gray-400 justify-between">
          <p className="text-md  font-semibold">{cb.name}</p>
        </div>
      )}
      <div className="flex gap-2">
        <div className="px-6 py-2 justify-center items-center flex flex-col text-white bg-green-700 rounded-lg gap-3">
          <p className={"text-2xl font-bold "}>{dayToday}</p>
          <p className="text-sm font-light">{dayDay}</p>
        </div>
        {/* BUILD TIME STATUS */}
        <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
          <div className="flex justify-evenly ">
            <div className="flex flex-col gap-0.5 items-center justify-center">
              <p className="text-md font-semibold">
                {getIndochinaTime(cb.check_in)}
              </p>
              <p className="text-xs font-normal text-gray-400">Check In</p>
            </div>
            <div className="border-s border-gray-400 h-full"></div>
            <div className="flex flex-col gap-0.5 items-center justify-center ">
              <p className="text-md font-semibold">
                {getIndochinaTime(cb.check_out)}
              </p>
              <p className="text-xs font-normal text-gray-400">Check Out</p>
            </div>
            <div className="border-s border-gray-400 h-full"></div>
            <div className="flex flex-col gap-0.5 items-center justify-center">
              <p className="text-md font-semibold">
                {timeDifference(cb.check_in, cb.check_out)}
              </p>
              <p className="text-xs font-normal text-gray-400">Total Hours</p>
            </div>
          </div>
          <div className="flex gap-1.5 justify-center items-center">
            <MapPin weight="fill" size={16} className="text-green-700" />
            <p className="font-semibold whitespace-nowrap text-xs">
              {cb.location}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardHistory;
